# import CategorizationActionItemResponseFragment from "../fragments/categorization-action-item-response.graphql"

mutation CreateCategorizationActionItemResponse(
  $data: CategorizationActionItemResponseInput!
) {
  createCategorizationActionItemResponse(data: $data) {
    ...CategorizationActionItemResponseFragment
  }
}
